import React from 'react';
import HeroSection from './HeroSection';
import DeepMirror from './DeepMirror';
import GrandIllusion from './GrandIllusion';
import ParadigmShift from './ParadigmShift';
import DeepCurriculum from './DeepCurriculum';
import JenniferGenesis from './JenniferGenesis';
import FinalGateway from './FinalGateway';
import Footer from '../../components/layout/Footer';

const BeziehungsheilungDE = () => (
  <main className="bg-dark min-h-screen overflow-x-hidden">
    <h1 className="sr-only">
      Beziehungsheilung für Frauen – Emotionale Abhängigkeit lösen, Bindungstrauma heilen,
      Feminine Souveränität & magnetische Königinnen-Energie mit Jennifer Gräser
    </h1>
    <HeroSection />
    <DeepMirror />
    <GrandIllusion />
    <ParadigmShift />
    <DeepCurriculum />
    <JenniferGenesis />
    <FinalGateway />
    <Footer />
  </main>
);

export default BeziehungsheilungDE;